import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Input,
  FormGroup,
  CustomInput,
  Button,
  ButtonGroup,
  Form,
  InputGroupAddon,
  DropdownItem,
  DropdownMenu,
  ButtonDropdown,
  Card,
  CardBody,
  InputGroup,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import { localeOptions } from '../../../../../../constants/defaultValues';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import CodeSnippet from './CodeSinppet';
export default function Addons({
  saveIntegration,
  channelDetails,
  propertyId,
  integrationId,
  serviceProvider,
}) {
  const [emailList, setEmailList] = useState(
    channelDetails?.addOn?.emails || []
  );

  const handleSave = (e) => {
    var details = { ...channelDetails };
    console.log(details);
    details.addOn.emails = emailList;
    saveIntegration({ channelDetails: details });
  };

  const handleAddEmails = () => {
    let lst = [...emailList];
    lst.push({
      email: '',
      language: 'en',
    });
    setEmailList(lst);
  };

  const handlRemove = (e) =>
    setEmailList(emailList.filter((f, index) => index !== e));

  const handleChange = (e, index, name) => {
    let lst = [...emailList];
    lst[index][name] = e.target.value;
    setEmailList(lst);
  };

  return (
    <Fragment>
      <Card className="mb-4">
        <CardBody>
          <div className="text-center mb-2">
            <h6>Microsoft Outlook Add-on</h6>
            <span>Generate AI reply to emails without leaving outlook</span>
          </div>
          <Separator className="mb-3" />
          <div className="text-left mb-2">
            <h6>Authorized Email Addresses</h6>
            <p className="my-2 mb-3">
              List email addresses that are allowed to connect from Outlook
            </p>
          </div>
          {emailList.map((m, index) => (
            <div className="row mt-1  mb-2">
              <div className="col-md-10">
                <InputGroup>
                  <Input
                    value={m?.email}
                    type="text"
                    onChange={(e) => handleChange(e, index, 'email')}
                  ></Input>
                  <InputGroupAddon addonType="append">
                    <Input
                      type="select"
                      value={m?.language}
                      onChange={(e) => handleChange(e, index, 'language')}
                    >
                      <option value="">Please select</option>
                      {localeOptions.map((elem) => (
                        <option value={elem.id}>{elem.name}</option>
                      ))}
                    </Input>
                  </InputGroupAddon>
                </InputGroup>
              </div>
              <div className="col-md-2 mt-1">
                <Button
                  color="danger"
                  outline
                  size="xs"
                  onClick={() => handlRemove(index)}
                >
                  X
                </Button>
              </div>
            </div>
          ))}
          <div className="row mt-1 ml-2 mb-3">
            <div className="d-flex w-100">
              <Button
                color="primary"
                outline
                size="xs"
                onClick={handleAddEmails}
              >
                + Add Email
              </Button>
            </div>
          </div>
          <div className="row justify-content-right mr-2 mb-3 ml-2">
            <CodeSnippet
              propertyId={propertyId}
              integrationId={integrationId}
              serviceProvider={serviceProvider}
            ></CodeSnippet>
          </div>
          <Separator className="mb-2" />
          <Colxx md="12" className="text-center mb-2">
            <Button
              onClick={() => handleSave()}
              color="primary"
              size="xs"
              outline
            >
              Save
            </Button>
          </Colxx>
        </CardBody>
      </Card>
    </Fragment>
  );
}
